import { css, html, ref, when } from '@genesislcap/web-core';
import { customEvent } from '@genesislcap/foundation-events';
import { SlottedStyles } from '@genesislcap/foundation-utils';
import { SplitOrderModal } from './split-order-modal';
import { DealConditionsForm } from '../deal-conditions-form/deal-conditions-form';
import { SinkingFundModal } from '../sinking-fund-modal/sinking-fund-modal';
import { PrincipalAmountModal } from '../principal-amount-modal/principal-amount-modal';
import { MaturityAmountEntry } from '../../cell-renderers/maturity-amount-entry';
import { splitOrderModalSlottedStyles } from './split-order-modal.styles';

DealConditionsForm;
SinkingFundModal;
PrincipalAmountModal;
MaturityAmountEntry;
SlottedStyles;

const slottedStyles = css`${splitOrderModalSlottedStyles}`;

export const splitOrderModalTemplate = html<SplitOrderModal>`
  <rapid-modal
    :onCloseCallback="${(x) => () => x.cancelRemoveSplit()}"
    ${ref('confirmRemoveSplitModal')}
  >
    <h3 slot="top">Remove Split</h3>
    <p>Remove split and restore single order?</p>
    <div slot="bottom">
      <rapid-button @click="${(x) => x.cancelRemoveSplit()}">Cancel</rapid-button>
      <rapid-button appearance="primary" @click="${(x) => x.confirmRemoveSplit()}">OK</rapid-button>
    </div>
  </rapid-modal>
  <rapid-modal
    class="split-order-modal"
    :onCloseCallback="${(x) => () => x.handleCancel()}"
    ${ref('modal')}
  >
    ${when(
      (x) => x.modalOpen,
      html<SplitOrderModal>`
        <h3 slot="top">Split Order</h3>
        <div class="split-order-modal-content">
          <div
            class="split-order-modal-body ${(x) => (x.conditionsActive ? 'conditions-open' : '')}"
          >
            <div class="split-order-grid-container" ${ref('gridContainer')}>
              <rapid-grid-pro
                @gridReady="${(x, ctx) => x.handleGridReady(customEvent(ctx))}"
                :gridOptions="${(x) => x.gridOptions}"
              >
                <slotted-styles :styles="${() => slottedStyles}"></slotted-styles>
              </rapid-grid-pro>
            </div>
            <div class="split-order-add-row" style="padding-left: ${(x) => x.addSplitOffset}px">
              <div class="split-order-add" @click="${(x) => x.addSplitRow()}">+ Add Split</div>
            </div>
            <sinking-fund-modal
              ?visible="${(x) => x.sinkingFundModalVisible}"
              schedule-json="${(x) => x.sinkingFundScheduleJson ?? ''}"
              panel-style="${(x) => x.sinkingFundPanelStyle}"
              @panel-mouseenter="${(x) => x.handleSinkingFundPanelMouseEnter()}"
              @panel-mouseleave="${(x) => x.handleSinkingFundPanelMouseLeave()}"
            ></sinking-fund-modal>
            <principal-amount-modal
              ?visible="${(x) => x.principalAmountModalVisible}"
              principal-amount="${(x) => x.principalAmountValue ?? ''}"
              ?value-highlighted="${(x) => x.principalAmountHighlighted}"
              anchor-top="${(x) => x.principalAmountAnchorTop}"
              anchor-left="${(x) => x.principalAmountAnchorLeft}"
            ></principal-amount-modal>
            ${when(
              (x) => x.conditionsActive && x.orderEditConditions,
              html<SplitOrderModal>`
                <div class="conditions-popup" ${ref('conditionsPopup')}>
                  <div class="conditions-header">
                    <div>Conditions</div>
                    <rapid-button
                      class="close-icon"
                      aria-label="close"
                      appearance="stealth"
                      @click="${(x) => x.closeConditionsPopup()}"
                    >
                      <rapid-icon name="times" size="lg"></rapid-icon>
                    </rapid-button>
                  </div>
                  <div class="conditions-form">
                    <deal-conditions-form
                      ${ref('conditionsForm')}
                      series-code="${(x) => x.seriesCode}"
                      series-size="${(x) => x.seriesSize}"
                      tax-status="${(x) => x.taxStatus}"
                      security-type="${(x) => x.securityType}"
                      deal-status="${(x) => x.dealStatus}"
                      ?order-amount-locked="${(x) => x.isConditionsOrderAmountLocked}"
                      @orderChanged="${(x, ctx) => x.handleOrderConditionsChanged(customEvent(ctx))}"
                      :munisOrder="${(x) => x.orderEditConditions}"
                      :flexMaturityOptions="${(x) => x.flexMaturityOptions || []}"
                    ></deal-conditions-form>
                  </div>
                </div>
              `,
            )}
          </div>
        </div>
        <div slot="bottom" class="split-order-modal-footer">
          ${when(
            (x) => x.splitOrderValidationMessage,
            html<SplitOrderModal>`
              <span class="split-order-validation-message">${(x) => x.splitOrderValidationMessage}</span>
            `,
          )}
          ${when(
            (x) => x.showRemoveSplit,
            html<SplitOrderModal>`
              <rapid-button appearance="outline" @click="${(x) => x.handleRemoveSplit()}">
                Remove Split
              </rapid-button>
            `,
          )}
          <rapid-button
            appearance="primary"
            ?disabled="${(x) => !x.canSaveSplit}"
            @click="${(x) => x.handleSave()}"
          >
            Save Split
          </rapid-button>
          <rapid-button class="split-cancel-button" @click="${(x) => x.handleCancel()}">Cancel</rapid-button>
        </div>
      `,
    )}
  </rapid-modal>
`;
